module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-masters/formula-details/formula-grid/formula-grid.component.css
// module id = ./src/app/hrms/payroll/payroll-masters/formula-details/formula-grid/formula-grid.component.css
// module chunks = main